import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import * as columnFormatters2 from "../../../../_metronic/layout/components/basePage/insidePages/column-formatters";

import { DatePickerField, Input } from "../../../../_metronic/_partials/controls";


export const initObject = {
  id: undefined,
  weekday: "",
  weekdaySolar: "",
  dateSolar: "",
  date: "",
  holiday: false
};


export const filterFields = [
  {
    name: "holiday",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.WORKDAY",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.HOLIDAY",
      },

    ],
  },

  {
    name: "date",
    lable: "MODULES.GENERAL.START_DATE",
    type: "date",
    list: [],
    component: DatePickerField
  },
  {
    name: "endDate",
    lable: "MODULES.GENERAL.END_DATE",
    type: "date",
    list: [],
    component: DatePickerField
  },

];

export const columns = [

  // {
  //   dataField: "date",
  //   text: columnFormatters.translateByMessageId("تاریخ میلادی"),
  //   // text: "نام سال تحصیلی",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "weekday",
  //   text: columnFormatters.translateByMessageId("روز هفته میلادی"),
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "dateSolar",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.DATE"),
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "weekdaySolar",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.DAY"),
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "holiday",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters2.HolidayColumnFormatter,
  },

];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "weekday",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.TERM.FORM_TITLE_PH",
        label: "MODULES.BASEINFO.TERM.FORM_TITLE",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "date",
        type: "date",
        component: DatePickerField,
        placeholder: "MODULES.BASEINFO.TERM.START_PH",
        label: "MODULES.BASEINFO.TERM.START",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "weekdaySolar",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.TERM.END_PH",
        label: "MODULES.BASEINFO.TERM.END",
        rowIdx: 3,
        class: "col-lg-4"
      },
    ]
  },
  {
    row: 2,
    list: [
      {
        name: "dateSolar",
        type: "text",
        component: Input,
        placeholder: "MODULES.BASEINFO.TERM.END_PH",
        label: "MODULES.BASEINFO.TERM.END",
        rowIdx: 4,
        class: "col-lg-4"
      },
      // {
      //   name: "holiday",
      //   type: "option",
      //   component: Checkbox,
      //   placeholder: "MODULES.GENERAL.STATUS",
      //   label: "MODULES.GENERAL.STATUS",
      //   rowOrder: 2,
      //   rowIdx: 6,
      //   class: "col-lg-4"
      // },

    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];


export const filterInitialValues = {
  filter: {
    holiday: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { holiday, searchText, date, endDate } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by holiday
  filter.holiday = holiday !== "" ? +holiday : undefined;

  // // Filter by all fields
  // filter.weekday = searchText;
  // if (searchText) {
  //   filter.weekday = searchText;
  // }
  newQueryParams.filter = filter;

  let whereClause = ""
  const whereClauseParameters = [];
  if (date && endDate) {
    whereClause = whereClause + "date>=@0 and date<=@1"
    whereClauseParameters.push(date)
    whereClauseParameters.push(endDate)

    if (filter.holiday !== undefined) {
      whereClause = whereClause + " and holiday=@2"
      whereClauseParameters.push(filter.holiday === 0 ? false : true)
    }
  }
  else if (filter.holiday !== undefined) {
    whereClause = whereClause + " holiday=@0"
    whereClauseParameters.push(filter.holiday === 0 ? false : true)
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};

// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  date: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  // yearId: Yup.number()
  //   .required("yearId is required"),
  // semesterId: Yup.number()
  //   .required("semesterId is required"),
  // date: Yup.number()
  //   .required("date is required"),
  // endDate: Yup.number()
  //   .required("endDate is required"),

});

